import { Suspense } from "react";
import RouteGuards from "@/router/RouteGuards";
import type { RouteConfig } from "@/router/types";
import { TranslationAlert } from "@/shared/components/TranslationAlert";
import { CenteredSpinner } from "@/shared/components/centeredSpinner";
import { useTranslationDetection } from "@/shared/hooks/useTranslationDetection";
import MainLayout from "@/shared/layouts/MainLayout";

type AppLayoutProps = { route: RouteConfig };

const AppLayout = ({ route }: AppLayoutProps) => {
  const { isTranslationDetected } = useTranslationDetection();

  const elementWithSuspense = (
    <Suspense fallback={<CenteredSpinner />}>
      {route.element}
    </Suspense>
  );

  // Public routes
  if (!route.isProtected) {
    if (route.useMainLayout === false) {
      return elementWithSuspense;
    }
    return (
      <MainLayout background={route.mainBackground} wide={route.mainWide}>
        {elementWithSuspense}
      </MainLayout>
    );
  }

  if (route.useMainLayout === false) {
    return (
      <RouteGuards>
        {elementWithSuspense}
      </RouteGuards>
    );
  }

  return (
    <RouteGuards>
      <MainLayout background={route.mainBackground} wide={route.mainWide}>
        {elementWithSuspense}
        {isTranslationDetected && <TranslationAlert isVisible={isTranslationDetected} />}
      </MainLayout>
    </RouteGuards>
  );
};

export default AppLayout;
